module.exports = __webpack_public_path__ + "img/profile.8a39c318.svg";